import * as apiPost from 'api/orderGuide/PostErpOrderGuideV1';

export type Type = {
	productId: string;
	priority: number;
	sourceId: string;
};

export function create(): Type {
	return {
		productId: '',
		priority: 0,
		sourceId: '',
	};
}

export function mapFromApiPost(input: apiPost.Product): Type {
	return {
		productId: input.productId,
		priority: input.priority,
		sourceId: input.sourceId,
	};
}
